import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ReactHtmlParser from 'react-html-parser';

const TranscriptWrapper = styled.div`
  padding: 0.75rem;
  border-radius: 0px;
  &.video {
    max-width: 660px;
    margin: 0 auto;
    width: calc(100% - 40px);
  }
  &::-webkit-scrollbar {
    background-color: var(--custom-white);
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c5ac99;
    border-radius: 10px;
  }
  div {
    margin-top: 1rem;
    display: none;
  }
  button {
    border: none;
    color: black;
    background-color: var(--custom-white);
    padding: 0.5rem;
    cursor: pointer;
    transform: translate(-0.75rem, 0);
    margin: 0 0.5rem 0.5rem 0;
    border-radius: 3px;
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    &:last-of-type {
      margin-right: 0;
    }
  }
  p {
    font-family: Benton, Helvetica, Arial, sans-serif;
    font-size: 0.75rem;
    line-height: 1rem;
    margin-bottom: 1rem;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
  &.viewable {
    background-color: var(--custom-white);
    color: black;
    border-radius: 3px;
    button {
      transform: translateX(0);
      color: white;
      background-color: var(--custom-blue);
    }
    div {
      display: block;
    }
    p {
      color: black;
    }
  }
`;

const Transcript = ({
  transcriptViewable,
  toggleTranscript,
  inlineAudioToggle,
  transcript,
  audio,
  videoTranscript,
}) => (
  <TranscriptWrapper
    className={`
      ${transcriptViewable ? 'viewable ' : null}
      ${videoTranscript ? 'video' : null}
    `}
  >
    <button
      className="transcript__button bentonsanscond-n6"
      onClick={() => toggleTranscript()}
      type="button"
    >
      {transcriptViewable ? `Hide ${videoTranscript ? 'video' : 'audio'} transcript` : `Read ${videoTranscript ? 'video' : 'audio'} transcript`}
    </button>
    {audio && (
      <button
        type="button"
        className="bentonsanscond-n6"
        onClick={() => inlineAudioToggle()}
      >
        Disable auto-playing media
      </button>
    )}
    <div>
      {ReactHtmlParser(transcript)}
    </div>
  </TranscriptWrapper>
);

Transcript.defaultProps = {
  transcriptViewable: null,
  videoTranscript: false,
};

Transcript.propTypes = {
  transcriptViewable: PropTypes.bool,
  toggleTranscript: PropTypes.func.isRequired,
  inlineAudioToggle: PropTypes.func.isRequired,
  transcript: PropTypes.string.isRequired,
  audio: PropTypes.bool.isRequired,
  videoTranscript: PropTypes.bool,
};

export default Transcript;
